var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.isDuplicate ? "发现重复导出任务" : "对账单导出进度",
        width: "560px",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.stopPolling,
      },
    },
    [
      _vm.isDuplicate
        ? [
            _c("el-alert", {
              attrs: {
                title: _vm.duplicateData.message || "相同条件的导出文件已存在",
                type: "warning",
                closable: false,
                "show-icon": "",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "export-info" }, [
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("文件名")]),
                _c("span", [_vm._v(_vm._s(_vm.duplicateData.fileName || "-"))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("创建时间")]),
                _c("span", [
                  _vm._v(_vm._s(_vm.duplicateData.createTime || "-")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("导出条件")]),
                _c("span", [
                  _vm._v(_vm._s(_vm.duplicateData.conditionSummary || "-")),
                ]),
              ]),
            ]),
          ]
        : [
            _c("div", { staticClass: "task-status" }, [
              _c("i", { class: _vm.statusIcon }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.statusText))]),
            ]),
            _vm._v(" "),
            _vm.task.status === "PROCESSING" || _vm.task.status === "COMPLETED"
              ? _c("el-progress", {
                  attrs: {
                    percentage: _vm.taskProgress,
                    status:
                      _vm.task.status === "COMPLETED" ? "success" : undefined,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.task.taskId
              ? _c("div", { staticClass: "export-info" }, [
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("任务编号"),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.task.taskId))]),
                  ]),
                  _vm._v(" "),
                  _vm.task.fileName
                    ? _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("文件名"),
                        ]),
                        _c("span", [_vm._v(_vm._s(_vm.task.fileName))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.task.fileSizeStr
                    ? _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("文件大小"),
                        ]),
                        _c("span", [_vm._v(_vm._s(_vm.task.fileSizeStr))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.task.completeTime
                    ? _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("完成时间"),
                        ]),
                        _c("span", [_vm._v(_vm._s(_vm.task.completeTime))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.task.errorMessage
                    ? _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("失败原因"),
                        ]),
                        _c("span", { staticClass: "error-message" }, [
                          _vm._v(_vm._s(_vm.task.errorMessage)),
                        ]),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pollingStoppedByNetwork
              ? _c("el-alert", {
                  attrs: {
                    title: "网络异常，自动查询已暂停，可点击“刷新状态”继续查询",
                    type: "warning",
                    closable: false,
                    "show-icon": "",
                  },
                })
              : _vm._e(),
          ],
      _vm._v(" "),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _vm._v(" "),
          !_vm.isDuplicate && _vm.pollingStoppedByNetwork
            ? _c(
                "el-button",
                {
                  attrs: { loading: _vm.detailLoading },
                  on: { click: _vm.refreshNow },
                },
                [_vm._v("刷新状态")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canRetry
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.retryLoading },
                  on: { click: _vm.handleRetry },
                },
                [_vm._v("重新导出")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.task.status === "WAITING"
            ? _c(
                "el-button",
                {
                  attrs: { type: "warning", loading: _vm.actionLoading },
                  on: { click: _vm.handleCancel },
                },
                [_vm._v("取消排队")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.task.status === "PROCESSING"
            ? _c(
                "el-button",
                {
                  attrs: { type: "danger", loading: _vm.actionLoading },
                  on: { click: _vm.handleStop },
                },
                [_vm._v("中止任务")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isDuplicate
            ? _c(
                "el-button",
                {
                  attrs: { type: "warning", loading: _vm.redoLoading },
                  on: { click: _vm.debouncedDuplicateReExport },
                },
                [_vm._v("重新导出")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.downloadUrl
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.redoLoading },
                  on: { click: _vm.downloadFile },
                },
                [_vm._v(_vm._s(_vm.isDuplicate ? "直接下载" : "下载文件"))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.openRecords } }, [
            _vm._v("查看导出记录"),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }